import { FC } from 'react';

import { Document } from 'types';
import { ReplaceDocumentTagsSources } from 'modules/documents/api/replaceDocumentTags';

import { Tooltip } from 'react-tooltip';
import DownloadDocument from './components/DownloadDocument';
import DocumentSpinner from './components/DocumentsSpinner';
import DocumentsOptionsList from './components/DocumentsOptionsList';

type DocumentsColumnProps = {
  className?: string;
  documents: Document[];
  documentsCount: number;
  downloadName?: string;
  hideOnMobile?: boolean;
  index: number;
  isLandscape?: boolean;
  sources?: ReplaceDocumentTagsSources;
  tableView?: boolean;
  templateWatermarkText?: string;
  tooltipText?: string;
};

const DocumentsColumn: FC<DocumentsColumnProps> = ({
  documents,
  downloadName,
  documentsCount,
  hideOnMobile = true,
  index,
  isLandscape = false,
  sources,
  tableView = true,
  templateWatermarkText = '',
  tooltipText = '',
}) => {
  const className = tableView
    ? `nk-tb-col ${hideOnMobile ? 'tb-col-xl' : ''} text-center align-middle`
    : `nk-file-${hideOnMobile ? 'members' : 'meta'} align-middle`;

  const documentId = documents[0]?._id || '';

  const showLoadedDocuments = () => {
    if (documents?.length === 1) {
      return (
        <DownloadDocument
          document={documents[0]}
          downloadName={downloadName}
          sources={sources}
          templateWatermarkText={templateWatermarkText}
          isLandscape={isLandscape}
        />
      );
    }
    if (documentsCount > 1) {
      if (documents.length === 1) {
        return <DocumentSpinner />;
      }
      return <DocumentsOptionsList documents={documents} />;
    }
    return <span>-</span>;
  };

  const content =
    documentsCount > 0 ? (
      showLoadedDocuments()
    ) : (
      <span className="btn btn-icon disabled">
        <em className="icon ni ni-file-download" />
      </span>
    );

  return tableView ? (
    <>
      {tooltipText && (
        <Tooltip
          content={tooltipText}
          id={`document-column-${documentId}`}
          place="bottom"
          style={{ zIndex: 999 }}
        />
      )}
      <td
        data-tooltip-id={`document-column-${documentId}`}
        className={className}
        key={`document-column-${index}`}
      >
        {content}
      </td>
    </>
  ) : (
    <>
      {tooltipText && (
        <Tooltip
          content={tooltipText}
          id={`document-div-${documentId}`}
          place="bottom"
          style={{ zIndex: 999 }}
        />
      )}
      <div
        data-tooltip-id={`document-div-${documentId}`}
        className={className}
        key={`document-div-${index}`}
      >
        {content}
      </div>
    </>
  );
};

export default DocumentsColumn;
